export default __webpack_public_path__ + "static/media/IMG20220611104150 - 6102 Koilada bindu madhava.9b7db725.jpg";